module.exports = {
  title: 'OE对应车型',
  route: {
    path: '/platform-goods-manage',
    children: {
      path: 'cars-corresponding-oe',
    },
  },
};
